// extracted by mini-css-extract-plugin
module.exports = {"cronometro":"style_cronometro__2v8Dw","relogioWrapper":"style_relogioWrapper__3VEy2","titulo":"style_titulo__CZBlL"};